<div class="profile-page">
    <div class="wrapper">
        <div class="page-header page-header-small" filter-color="orange">
            <div class="page-header-image" data-parallax="true" style="background-image: url('assets/images/introduction.jpg');">
            </div>
        <div class="container">
            <div class="content-center">
                <div class="profile-image">
                    <a href="#">
                        <img src="assets/images/vikas_4.png" alt="Profile Image" />
                    </a>
                </div>
                <div class="h2 title">Vikas Patel </div>
                <p class="category text-white">Full Stack Developer</p>
                <a class="btn bg-primary smooth-scroll mr-2" href="#contact" data-aos="zoom-in" data-aos-anchor="data-aos-anchor">Hire Me</a>
                <a class="btn bg-primary" href="https://drive.google.com/file/d/1zcjmAGJ9RqTkgn3bb0hchcefQEbouFCl/view?usp=sharing" target="_blank" data-aos="zoom-in" data-aos-anchor="data-aos-anchor">Download CV</a>
            </div>
        </div>
        <div class="section">
            <div class="container">
                <div class="button-container">
                    
                    
                    <a class="btn btn-default btn-round btn-lg btn-icon" href="https://www.linkedin.com/in/vikas-2jan/" target="_blank" rel="tooltip" title="Follow me on Linkedin">
                        <!-- <i class="fa fa-linkedin"></i> -->
                        <img src="assets/images/linked.png"  alt=LinkedIn>
                    </a>

                    <a style="background-color: white;" class="btn btn-default btn-round btn-lg btn-icon" href="https://github.com/vikas8452" target="_blank" rel="tooltip" title="Follow me on Github">
                        <!-- <i class="fa fa-github"></i> -->
                        <img src="assets/images/github.png" alt="Github">
                    </a>

                    <a class="btn btn-default btn-round btn-lg btn-icon" href="https://www.instagram.com/_techbit_/" target="_blank" rel="tooltip" title="Follow me on Instagram">
                        <!-- <i  class="fa fa-instagram"></i> -->
                        <img src="assets/images/insta.png" alt="Instagram">
                    </a>
                    
                </div>
            </div>
        </div>
        </div>
    </div>
</div>